import './index.css';
import { jsx } from 'react/jsx-runtime';
import { Children, cloneElement } from 'react';
import classnames from 'classnames';

var styles = {"button-stack":"magritte-button-stack___iVaJJ_2-1-47","buttonStack":"magritte-button-stack___iVaJJ_2-1-47","button-stack_auto":"magritte-button-stack_auto___dqMc9_2-1-47","buttonStackAuto":"magritte-button-stack_auto___dqMc9_2-1-47","button-stack_vertical":"magritte-button-stack_vertical___BNea1_2-1-47","buttonStackVertical":"magritte-button-stack_vertical___BNea1_2-1-47","button-stack_horizontal":"magritte-button-stack_horizontal___W247X_2-1-47","buttonStackHorizontal":"magritte-button-stack_horizontal___W247X_2-1-47","button-stack-item":"magritte-button-stack-item___EHJWa_2-1-47","buttonStackItem":"magritte-button-stack-item___EHJWa_2-1-47"};

const ButtonStack = ({ children, orientation = 'auto', 'data-qa': dataQa = 'button-stack', }) => {
    return (jsx("div", { className: classnames(styles.buttonStack, styles[`button-stack_${orientation}`]), "data-qa": dataQa, children: Children.map(children, (child, index) => {
            if (!child) {
                return null;
            }
            return (jsx("div", { className: classnames({ [styles.buttonStackItem]: orientation !== 'vertical' }), children: cloneElement(child, { stretched: true }) }, index));
        }) }));
};

export { ButtonStack };
//# sourceMappingURL=ButtonStack.js.map
